import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromEvents from '../reducers/events.reducer';
import * as fromRoot from '../../../store';
import { Event } from '../../models';
import { compareAsc, isBefore, parseISO, startOfDay } from 'date-fns';

export const getEventsState = createSelector(fromFeature.getEventState, (state: fromFeature.EventState) => state.events);

export const getEventEntities = createSelector(getEventsState, fromEvents.getEventsEntities);
export const getEventsLoading = createSelector(getEventsState, fromEvents.getEventsLoading);
export const getEventsLoaded = createSelector(getEventsState, fromEvents.getEventsLoaded);
export const getEventsOverviewLoading = createSelector(getEventsState, fromEvents.getEventsOverviewLoading);
export const getEventsOverviewLoaded = createSelector(getEventsState, fromEvents.getEventsOverviewLoaded);
export const getEventsPage = createSelector(getEventsState, fromEvents.getEventsPage);
export const getEventError = createSelector(getEventsState, fromEvents.getEventError);

export const getAllEvents = createSelector(getEventEntities, entities => {
  return Object.keys(entities).map(id => entities[id]);
});

export const getFeaturedEvents = createSelector(getAllEvents, events => {
  return events.filter(event => event.featured);
});

export const getSelectedEvent = createSelector(getAllEvents, fromRoot.getRouterState, (events, router) => {
  if (!router.state) return null;
  const eventId = +router.state.params?.['eventId'] || +router.state.data?.['eventId'];
  const eventDate = router.state.params?.['eventDate'];
  const trackingKey = eventDate && `${eventId}_${eventDate?.replace(/-/g, '')}`;

  return router.state && events.find(a => a.id === eventId && (!trackingKey || a.trackingKey === trackingKey))!;
});

export const getSelectedEventLoading = createSelector(getEventsLoading, fromRoot.getRouterState, (loading, router): boolean => {
  if (!router.state) return false;
  const eventId = router.state.params?.['eventId'] || +router.state.data?.['eventId'];
  const eventDate = router.state.params?.['eventDate'];
  const trackingKey = eventDate && `${eventId}_${eventDate?.replace(/-/g, '')}`;

  return router.state && loading.some(a => (!trackingKey ? a === eventId : a === trackingKey));
});

export const getSelectedEventLoaded = createSelector(getEventsLoaded, fromRoot.getRouterState, (loaded, router): boolean => {
  if (!router.state) return false;
  const eventId = router.state.params?.['eventId'] || +router.state.data?.['eventId'];
  const eventDate = router.state.params?.['eventDate'];
  const trackingKey = eventDate && `${eventId}_${eventDate?.replace(/-/g, '')}`;

  return router.state && loaded.some(a => (!trackingKey ? a === eventId : a === trackingKey));
});

export const getSelectedEventNoDateLoaded = createSelector(getEventsLoaded, fromRoot.getRouterState, (loaded, router): boolean => {
  if (!router.state) return false;
  const eventId = router.state.params?.['eventId'] || +router.state.data?.['eventId'];
  return router.state && loaded.some(a => +a.split('_')[0] === +eventId);
});

function getEffectiveStartDate(event: Event, customToday: Date): Date {
  const eventDate = startOfDay(parseISO(event.startDate));
  return isBefore(eventDate, customToday) ? customToday : eventDate;
}
